import { Component, OnInit } from '@angular/core';
import {AdminCompetitionService} from '../../../../services/admin/admin-competition.service';
import {ActivatedRoute, Params} from '@angular/router';
import {CompetitionParticipantSchoolFilter, CompetitionParticipantSchoolModel} from '../../../../models/competition/competition.model';
import {AdminSchoolSelectionService} from '../../../shared/admin-school-selection/admin-school-selection.service';
import {forkJoin} from 'rxjs';
import {ModalService} from '../../../../shared/modals/modal/modal.service';
import {ErrorModel} from '../../../../models/shared/error.model';

@Component({
  selector: 'app-admin-competitions-schools',
  templateUrl: './admin-competitions-schools.component.html',
  styleUrls: ['./admin-competitions-schools.component.css']
})
export class AdminCompetitionsSchoolsComponent implements OnInit {

  compId: string;
  participantSchools: CompetitionParticipantSchoolModel[] = [];
  selectedParticipantSchools: CompetitionParticipantSchoolModel[] = [];
  public filter = new CompetitionParticipantSchoolFilter();
  hasMoreData = true;

  constructor(private route: ActivatedRoute,
              private compSv: AdminCompetitionService,
              private modalSv: ModalService,
              private selectSchoolsSv: AdminSchoolSelectionService) { }

  ngOnInit() {

    this.route.parent.params.subscribe((params: Params) => {
      this.compId = params.competitionId;
      this.onFetchMoreSchools();
    });

  }

  onFetchFresh() {
    this.participantSchools = [];
    this.onFetchMoreSchools();
  }

  onFetchMoreSchools() {

    if (this.compId) {

      this.filter.skip = this.participantSchools.length;
      this.compSv.fetchParticipantSchoolsAsParticipants(this.compId, this.filter).subscribe((schools) => {
        this.participantSchools = this.participantSchools.concat(schools);
        this.hasMoreData = schools.length === this.filter.limit;
      });

    }

  }

  onAddSchools() {

    this.selectSchoolsSv.show().subscribe((schools) => {

      if (schools && schools.length > 0) {

        const addSchoolCalls = [];
        for (const school of schools) {
          const addSchool = this.compSv.addParticipantSchool(this.compId, school._id);
          addSchoolCalls.push(addSchool);
        }

        forkJoin(addSchoolCalls).subscribe(() => {
          this.modalSv.showAlertModal('Success', 'Schools successfully added');
          this.participantSchools = [];
          this.onFetchMoreSchools();
        }, (err: ErrorModel) => {
          this.modalSv.showTranslatedErrorModal(err);
        });

      }

    });

  }

  onRemoveSchools() {

    if (this.selectedParticipantSchools.length > 0 && this.compId) {

      this.modalSv.showChoiceModal('Warning', 'Are you sure you want to remove the school?').subscribe((value) => {

        if (value === true) {

          const removeSchoolCalls = [];
          for (const school of this.selectedParticipantSchools) {
            const removeSchool = this.compSv.removeParticipantSchool(this.compId, school.schoolId);
            removeSchoolCalls.push(removeSchool);
          }

          forkJoin(removeSchoolCalls).subscribe(() => {
            this.participantSchools = [];
            this.selectedParticipantSchools = [];
            this.onFetchMoreSchools();
            this.modalSv.showAlertModal('Success', 'Schools successfully removed');
          }, (err: ErrorModel) => {
            this.modalSv.showTranslatedErrorModal(err);
          });

        }

      });

    }

  }

  onParticipantSchoolsSelected(schools: CompetitionParticipantSchoolModel[]) {
    this.selectedParticipantSchools = schools;
  }

  onParticipantSchoolClicked(school: CompetitionParticipantSchoolModel) {
    // Handle participant school click if needed
  }

}
